import { render } from "./AcceptanceReceiptPageList.vue?vue&type=template&id=6199de8a&scoped=true"
import script from "./AcceptanceReceiptPageList.vue?vue&type=script&lang=ts"
export * from "./AcceptanceReceiptPageList.vue?vue&type=script&lang=ts"

import "./AcceptanceReceiptPageList.vue?vue&type=style&index=0&id=6199de8a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6199de8a"

export default script